/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ReshuffleInputs */



/**
* | output |
* | --- |
* | "Reshuffle" |
*
* @param {Error_ReshuffleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_reshuffle = /** @type {((inputs?: Error_ReshuffleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ReshuffleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Neu mischen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remélanger")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("重新洗牌")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("重新洗牌")
	if (locale === "ko") return /** @type {LocalizedString} */ ("다시 섞기")
	return /** @type {LocalizedString} */ ("Reshuffle")
});